<template>
    <b-container>
        <b-card>
            <tab-nav :tabs="true" id="myTab-1">
                <tab-nav-items :active="true" id="entrenadores-tab" ariaControls="entrenadores" role="tab" :ariaSelected="true" title="Entrenadores" />
                <tab-nav-items :active="false" id="deportistas-tab" ariaControls="deportistas" role="tab" :ariaSelected="false" title="Deportistas" />
                <tab-nav-items :active="false" id="calendario-tab" ariaControls="calendario" role="tab" :ariaSelected="false" title="Calendario" />
            </tab-nav>
            <tab-content id="myTabContent">
                <tab-content-item :active="true" id="entrenadores" aria-labelled-by="entrenadores-tab">
                    <b-row>
                        <b-col>
                            <vue-element-loading :active="loading" text="Obteniendo información ..." spinner="bar-fade-scale" />
                            <b-table
                            :items="coaches"
                            :fields="coachesFields"
                            show-empty
                            @row-clicked="coachRowClicked"
                            hover
                            empty-text="Sin datos para mostrar"
                            head-variant="light"
                            >
                            </b-table>
                        </b-col>
                    </b-row>
                    <!-- <button @click="log">log:dev</button> -->
                </tab-content-item>
                <tab-content-item :active="false" id="deportistas" aria-labelled-by="deportistas-tab">
                    <b-row>
                        <b-col>
                            <vue-element-loading :active="loading" text="Obteniendo información ..." spinner="bar-fade-scale" />
                            <b-table
                                :items="athletes"
                                :fields="athletesFields"
                                :key="athletesKey"
                                @row-clicked="clientRowClicked"
                                show-empty
                                hover
                                empty-text="Sin datos para mostrar"
                                head-variant="light"
                            >
                            </b-table>
                        </b-col>
                    </b-row>
                </tab-content-item>
                <tab-content-item :active="false" id="calendario" aria-labelled-by="calendario-tab">
                    <vue-cal
                        style="height: 550px"
                        active-view="month"
                        :disable-views="['years', 'year']"
                        today-button
                        :time="false"
                        events-on-month-view="short"
                        locale="es"
                        selected-date="2021-06-23"
                        :events="eventsList"
                    />
                </tab-content-item>
            </tab-content>
        </b-card>
    </b-container>
</template>

<script>
import { core } from '@/config/pluginInit';
import moment from 'moment';
import axios from 'axios';
import config from '@/config/constant';
import tabContentItem from '../../../components/core/tab/tab-content-item.vue';
import Counter from '@/components/core/counter/Counter'
import VueCal from 'vue-cal'
import 'vue-cal/dist/vuecal.css'
import 'vue-cal/dist/i18n/es.js'

export default {
    components: {
        tabContentItem,
        Counter,
        VueCal
    },
    data() {
        return {
            loading: true,
            athletes: [],
            athletesKey: 1,
            athletesFields: [
                { key: 'firstName', label: 'Nombre', sortable: true },
                { key: 'lastName', label: 'Apellido', sortable: true },
                { key: 'gender', label: 'Genero', sortable: true },
                { key: 'email', label: 'Correo Electrónico', sortable: true }
            ],
            coachesFields: [
                { key: 'firstName', label: 'Nombre', sortable: true },
                { key: 'lastName', label: 'Apellido', sortable: true },
                { key: 'gender', label: 'Genero', sortable: true },
                { key: 'routineCount', label: 'Conteo Rutinas', sortable: true },
                { key: 'email', label: 'Correo Electrónico', sortable: true }
            ],
            allCoaches: [],
            coaches: [],
            eventsList: [],
            routines: null,
            tests: [],
            competitions: []
        }
    },
    methods: {
        log(){
            console.log('Coaches', this.coaches);
        },
        async getSportGroups(key) {
            axios.get(`${config.apiUrl}/sportGroups/${key}`)
            .then(async r => {
                console.log('✅ Sports Groups', r.data.data);
                const coachesList = await axios.get(`${config.apiUrl}/coaches/all`);
                if(r.data.data.length > 0){
                    r.data.data.forEach(e => {
                        this.getGroupsMembers(e.key);
                        coachesList.data.data.filter(c => {
                            if(c.key == e.item.coach_id){
                                axios.get(`${config.apiUrl}/coachGroupRoutines/${e.item.id}`)
                                .then(r => {
                                    const currentGender = this.$route.params.gender
                                    if(currentGender) {
                                        if(c.item.gender != currentGender) return
                                    }
                                    this.coaches.push({...c.item,...{'routineCount': r.data.data.length}});
    
                                    // Mapeamos las rutinas en el calendario
                                    r.data.data.forEach(q => {
                                        const eventDate = moment(new Date(q.item.routine_date._seconds * 1000), "YYYY-MM-DD").format("YYYY-MM-DD");
                                        const routineData = this.routines.filter(t => {
                                            if(t.key == q.item.routine_id){
                                                return q.item;
                                            }
                                        })[0];
                                        const eventData = routineData?.item ?? routineData
                                        console.log('❗️❗️ Rou', (routineData?.item ?? routineData));
                                        this.eventsList.push({
                                            start: eventDate,
                                            end: eventDate,
                                            title: `R: ${eventData?.name ?? 'Sin nombre'}`,
                                            content: `<i class="v-icon material-icons">Ritmo Cardíaco: ${eventData?.heart_rate}</i>`,
                                            class: 'rutina'
                                        });
                                    });
                                })
                            }
                        });                    
                    });
                }else{
                    this.loading = false;
                }
            })
            .catch(e => {
                console.error('❌ Error getting sports groups', e);
            })
        },
        /**
         * key: @group_id Recibe el id del grupo, para traer la data
         */
        getGroupsMembers(key) {
            axios.get(`${config.apiUrl}/groupMembers/${key}`)
            .then(r => {
                console.log('✅ Get Groups Members', r.data.data);
                this.loading = false;
                r.data.data.forEach(d => {
                    // Buscamos la data de cada deportista
                    let clientData = '';
                    axios.get(`${config.apiUrl}/users/bykey/${d.item.client_id}`)
                    .then(res => {
                        clientData = res.data.data.item;
                        // console.log("✅", clientData);
                        const found = this.athletes.find(a => a.id === res.data.data.item.id)
                        if(!found){
                            const currentGender = this.$route.params.gender
                            if(currentGender){
                                if(res.data.data.item.gender != currentGender) return
                            }
                            this.athletes.push(res.data.data.item);
                        }
                        this.loading = false;
                    })
                    .catch(e => {
                        console.error('❌ Error getting athlete info', e);
                    })

                    // Encontramos los tests de los deportistas asignados
                    axios.get(`${config.apiUrl}/tests/${d.item.client_id}`)
                    .then(t => {
                        // console.log('✅ Tests', t.data.data);
                        t.data.data.forEach(test => {
                            this.tests.push(test.item);
                            let eventDate = moment(new Date(test.item.activity_date._seconds * 1000), "YYYY-MM-DD").format('YYYY-MM-DD');
                            this.eventsList.push({
                                start: eventDate,
                                end: eventDate,
                                title: `T: ${test.item.test_name}: ${clientData.firstName ?? ""} ${clientData.lastName ?? ""}`,
                                content: `<i class="v-icon material-icons">Ritmo Cardíaco: ${test.item.test_result}</i>`,
                                class: 'test',
                                baseData: test
                            });
                        })
                    })
                    .catch(e => {
                        console.error(e)
                    })

                    // Encontramos las competiciones del usuario
                    axios.get(`${config.apiUrl}/clientCompetitions/${d.item.client_id}`)
                    .then(r => {
                        r.data.data.forEach(d => {
                            this.competitions.filter(c => {
                                if(d.item.competition_id == c.key){
                                    let eventDate = moment(new Date(d.item.competition_date._seconds * 1000), "YYYY-MM-DD").format('YYYY-MM-DD');
                                    // console.log('✅ Competition found', c);
                                    this.eventsList.push({
                                        start: eventDate,
                                        end: eventDate,
                                        title: `C: ${c.item.name}: ${clientData.firstName} ${clientData.lastName}`,
                                        content: `<i class="v-icon material-icons">Tipo: ${d.item.competition_type}, Duración: ${d.item.competition_duration}</i>`,
                                        class: 'competition'
                                    });
                                } 
                            });
                        });
                    })
                    .catch(e => {
                        console.error('Error getting Client Competitions', e);
                    })

                   

                });
            })
            .catch(e => {
                console.error('❌ Error getting groups members', e);
            })
        },
        /**
         * key: @coach_id Recibe el id del coach para traer su data
         */
        getCoachData(key){
            axios.get(`${config.apiUrl}/coach/bykey/${key}`)
            .then(r => {
                console.log('✅ Coach data', r.data.data);
                this.coaches.push(r.data.data);
            })
            .catch(e => {
                console.error('❌ Error coach data', e);
            })
        },
        getAllCoaches(){
            axios.get(`${config.apiUrl}/coaches/all`)
            .then(r => {
                this.allCoaches = r.data.data;
                console.log('✅ Coaches all', r.data.data);
            });
        },
        getAllRoutines(){
            axios.get(`${config.apiUrl}/routines/all`)
            .then(r => {
                console.log('✅ All Routines', r.data.data);
                this.routines = r.data.data;
            })
            .catch(e => {
                console.error('❌ Error getting all routines', e);
            })
        },
        getAllCompetitions () {
            axios.get(`${config.apiUrl}/competitions/all`)
            .then(r => {
                console.log('✅ Get Competitions', r.data.data)
                this.competitions = r.data.data;
            })
            .catch(e => {
                console.error('Error Competitions', e)
            })
        },
        clientRowClicked(row){
            console.log(row)
            this.$router.push({ name: 'atpro.client-profile', params: { id: row.id } })
        },
        coachRowClicked(row){
            this.$router.push({ name: 'atpro.coach-profile', params: { id: row.id } })
        }
    },
    created(){
        this.getAllRoutines();
        this.getAllCompetitions();
    },
    mounted () {
        core.index();
        // this.getAllCoaches();
        this.getSportGroups(this.$route.params.id);
    },
}
</script>

<style lang="css">
.vuecal__event.rutina {background-color: lightblue;border: 1px solid darkblue;}
.vuecal__event.test {background-color: lightseagreen;border: 1px solid rgb(3, 149, 227);}
.vuecal__event.competition {background-color: lightgreen;border: 1px solid darkgreen;}
.vuecal__cell--has-events {background-color: #fffacd;}
.vuecal__cell-events-count {display: none;}
.vuecal--month-view .vuecal__cell {height: 80px;}

.vuecal--month-view .vuecal__cell-content {
  justify-content: flex-start;
  height: 100%;
  align-items: flex-end;
}

.vuecal--month-view .vuecal__cell-date {padding: 4px;}
.vuecal--month-view .vuecal__no-event {display: none;}
</style>